module.exports = __webpack_public_path__ + "img/logo-empresa.c7c1ce37.png";